import React, { useEffect, useRef, useState } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Admin_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
// import {removeData} from  ''
import { removeData } from '../reduxactions/adminactions/AHospitallistActions';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { RootState } from '../reducers';
import { useNavigate } from 'react-router-dom';

export const AdminHospitallist = () => {

  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('')

  const dispatch = useDispatch();


  const [hospital, setHospital] = useState<[]>([]);
  const getdata = async () => {
    try {
      const payload = { q: 1 };
      const apiname = Admin_API.Hospital_API;
      const data = await LoginService.getData(apiname, payload);
      setHospital(data);
    } catch (error) {

    }
  };

  useEffectOnce(() => {
    getdata()

  }, []);


  const remove = useSelector((state: RootState) => state.ahospital.remove);
  const toast = useRef(remove);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);


  const [removedata, setRemoveData] = useState({
    SupervisorID: '',
  });

  const Removeduring = (rowData: any) => {
    setRemoveData({
      SupervisorID: rowData.SupervisorID,
    });
    setDeleteConfirmation(true);
  }
  const toast2 = useRef<Toast>(null)
  const confirmDelete = async () => {
    const { SupervisorID } = removedata;

    const payload = { q: 2, asid: SupervisorID };
    const apiname = Admin_API.Hospital_API;
    const response = await LoginService.getData(apiname, payload);
    // toast.current.show({ severity: 'error', summary: 'Supervisor Delete successfully', life: 3000 });
    setDeleteConfirmation(false);
    if (toast2.current) {
      toast2.current.show({ severity: 'success', detail: response });
    }
    getdata()
  };

  const cancelDelete = () => {
    setDeleteConfirmation(false);

  }
  const navigate = useNavigate();
  const viewPage = (rowData: any) => {
    const url = `/viewhospital/${rowData.SupervisorID}`;
    console.log('rowdata:', rowData.SupervisorID)
    navigate(url);
  }
//for help
 const [openHelp, setHelp] = useState(false);
 const url1 = window.sessionStorage.getItem("apiRoot");
 const IUrl = `${url1}/help/adminhospital.php`;
 const helpImg = `${url1}/help/help3.png`;
 const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
   event.preventDefault();
   const newWindowReference = window.open(
     targetUrl,
     'newwindow',
     'width=1000,height=1000,noopener,noreferrer'
   );
 
   if (newWindowReference) {
       newWindowReference.opener = null;
   }
 };
  return (
    <div >
      <div className="content-wrapper" style={{ marginLeft: '100px' }}>
        <section className="content-header">
          <div className="container-fluid">
            <div className="grid mb-2">
              <div className="col-6">
              </div>
            </div>
          </div>
        </section>
        <section className="content" style={{ marginLeft: '110px' }} >
          <div className="row">
            <div className="col-md-12">
              <div className="card-header p-2" style={{ marginTop: '50px' }}>
                <h2>Hospital List</h2>
              </div>
 <div className="col-16" style={{ textAlign:"right"}}>
                <a
                  title="help"
                 onClick={(e) => openWindow(e, IUrl)}
                  style={{
                   
                    color: "blue",
                    fontSize: 15, cursor: "pointer"
                  }}
                >Help for this Page &nbsp;
                <i style={{marginTop: 40,backgroundColor: "orange",color:"white" }} className = "pi pi-question-circle"></i>
                 
                </a>
              </div>
              <br></br>
              <div className="box box-primary">
                <div className="card">
                  <p className="m-0">
                    <div>
                      <div className="card flex flex-wrap justify-content">
                        <span className="p-input-icon-left">
                          <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                          <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                        </span>

                      </div>
                      <DataTable value={hospital} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} rowClassName={() => 'custom-row-height'} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                        globalFilterFields={['hospitalname', 'firstname', 'lastname', 'createddate','Status']} >
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                        <Column field="hospitalname" sortable header="Hospital Name"></Column>
                        <Column field="firstname" sortable header=" First Name"></Column>
                        <Column field="lastname" sortable header="Last Name"></Column>
                        <Column field="createddate" sortable header="Date"></Column>
                        <Column header="Status" sortable body={(rowData) => rowData.status ? rowData.status.charAt(0).toUpperCase() + rowData.status.slice(1).toLowerCase() : ''} />
                        <Column header="Operation" body={(rowData) => (
                          <>
                            <Button className='mr-1' tooltip="View" severity="info" icon="pi pi-eye" rounded outlined onClick={() => viewPage(rowData)} />
                            <Button icon="pi pi-trash" tooltip="Delete" rounded outlined className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'red' }} onClick={() => Removeduring(rowData)} />
                          </>
                        )} />
                      </DataTable>

                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>



      < Dialog header="Confirm Delete" style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
        <div>Are you really want to Remove...?</div>
        <br></br>
        <Button label="Delete" icon="pi pi-check" className='mr-3 p-button-raised' onClick={confirmDelete} />
        <Button label="Close" icon="pi pi-times" onClick={cancelDelete} className="mr-3 p-button-secondary" />
      </Dialog >



      <Toast ref={toast2} ></Toast>




    </div>
  )
}
